import React from 'react';
import { Modal, Button } from 'antd';
import { ReactComponent as ExclamationCircleIcon } from '../../assets/icons/common/exclamation-circle.svg';
import { ReactComponent as SuccessIcon } from '../../assets/icons/common/success.svg';
import '../../styles/components/_modal.scss';
import SvgIcon from '../SvgIcon';
import { MODAL } from '../../utils/constants/itemScreen';
import { ModalConfirmProps } from '../../interfaces/common';

const ModalConfirm: React.FC<ModalConfirmProps> = ({
  isOpen,
  title = 'Confirm',
  message = '',
  handleLeftButton,
  handleRightButton,
  textLeftButton = MODAL.CANCEL,
  textRightButton = MODAL.OK,
  icon,
  modalType,
  width,
  actionButtons,
}) => {
  return (
    <Modal
      keyboard={false}
      open={isOpen}
      title={null}
      footer={null}
      centered
      maskClosable={false}
      closable={false}
      onCancel={handleLeftButton}
      className="sys-modal-container"
      width={width}
    >
      <div className="sys-modal modal-confirm">
        <div className="sys-modal__header">
          <div className="sys-modal__header-icon">
            {icon || modalType === 'success' ? <SvgIcon svg={SuccessIcon} /> : <SvgIcon svg={ExclamationCircleIcon} />}
          </div>
          {title && <div className="sys-modal__header-title">{title}</div>}
        </div>
        <div className="sys-modal__content">
          <p>{message}</p>
        </div>
        <div className="sys-modal__footer">
          {actionButtons ? (
            actionButtons
          ) : (
            <>
              {handleLeftButton && (
                <Button autoInsertSpace={false} className="sys-modal__button sys-modal__button--left" onClick={handleLeftButton}>
                  {textLeftButton}
                </Button>
              )}
              <Button
                autoInsertSpace={false}
                className="sys-modal__button sys-modal__button--right"
                type="primary"
                onClick={handleRightButton}
              >
                {textRightButton}
              </Button>{' '}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ModalConfirm;
